import { create } from 'zustand';
import { Therapist, Credit, User } from '../../../core/types';
import * as api from '../../../core/api/services';
import { storageMgt } from '../../../core/utils/storage';
import { Preferences } from '../../../core/types';

interface HomepageState {
  therapists: Therapist[];
  sessionCredit: Credit;
  isLoading: boolean;

  fetchTherapists: () => Promise<Therapist[]>;
  getSessionCredit: () => Promise<Credit>;
  retrieve: () => User | null;
  retrieveLocalPrefs: () => Preferences | null;
}

export const useHomepageStore = create<HomepageState>((set) => ({
  therapists: [],
  sessionCredit: { quantity: 0 },
  isLoading: false,

  fetchTherapists: async () => {
    set({ isLoading: true });
    try {
      const result = await api.fetchTherapists();
      set({ therapists: result, isLoading: false });
      return result;
    } catch {
      set({ isLoading: false });
      return [];
    }
  },

  getSessionCredit: async () => {
    try {
      const user = storageMgt.getUser();
      
      if (!user?.id) return { quantity: 0 };
      const result = await api.getSessionCredit(user.id);
      set({ sessionCredit: result });
      return result;
    } catch {
      return { quantity: 0 };
    }
  },

  retrieve: () => storageMgt.getUser(),
  retrieveLocalPrefs: () => storageMgt.getPrefs(),
}));
